import { useState } from "react";
import { KeyRound } from "lucide-react";
import { api, errorText, setAdminToken } from "@/lib/api";
import { unlockAudio } from "@/lib/sound";

export const PinLogin = ({ onSuccess, eyebrow = "Yönetim", title = "PIN gir", subtitle = "Galeri, slayt ve etkinlik varlıkları PIN ile korunur." }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    unlockAudio();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/admin/login", { pin });
      setAdminToken(data.token);
      onSuccess();
    } catch (err) {
      setError(errorText(err, "Giriş başarısız"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="glass w-full max-w-sm p-6 sm:p-8" data-testid="pin-login-form">
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="font-display mt-2 text-2xl font-extrabold">{title}</h1>
      <p className="mt-1 text-sm text-slate-400">{subtitle}</p>
      <input
        type="password"
        inputMode="text"
        autoFocus
        value={pin}
        onChange={(e) => setPin(e.target.value)}
        placeholder="••••••••"
        className="input mt-5 text-center tracking-[0.4em]"
        data-testid="admin-pin-input"
      />
      {error && <p className="mt-3 text-sm text-red-400" data-testid="pin-error">{error}</p>}
      <button className="btn btn-accent mt-5 w-full" disabled={busy || !pin} data-testid="pin-submit-button">
        <KeyRound size={18} /> Giriş
      </button>
    </form>
  );
};
